import { accountantIbkApi, clientIbkApi } from '@ibk/shared-config';
export const buildListProductCatalogQuery = ({ isVisible = true, category } = {}) => ({
    url: '/v1/benefits/products',
    method: 'GET',
    params: {
        isVisible: String(isVisible),
        ...(category ? { category } : {}),
    },
});
export const transformListProductCatalogResponse = (response) => response.result;
export const accountantProductCatalogApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        listAccountantProductCatalog: build.query({
            query: params => buildListProductCatalogQuery(params ?? undefined),
            transformResponse: transformListProductCatalogResponse,
        }),
    }),
    overrideExisting: false,
});
export const clientProductCatalogApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        listClientProductCatalog: build.query({
            query: params => buildListProductCatalogQuery(params ?? undefined),
            transformResponse: transformListProductCatalogResponse,
        }),
    }),
    overrideExisting: false,
});
export const { useListAccountantProductCatalogQuery } = accountantProductCatalogApi;
export const { useListClientProductCatalogQuery } = clientProductCatalogApi;
